export const sites = {
workspace: {
assets: "Actifs",
sites: "Sites",
},
list: {
  showAllSites: "Afficher tous les sites",
  emptyArchivedSub: "Les sites que vous archivez sont conservés ici. Ouvrez-en un pour le restaurer.",
  emptyArchivedTitle: "Aucun site archivé",
  queueArchived: "Archivés",
title: "Sites",
subtitle_one: "{{count}} site",
subtitle_other: "{{count}} sites",
searchPlaceholder: "Rechercher des sites…",
searchA11y: "Rechercher des sites",
refine: "Affiner",
refineSheetTitle: "Affiner les sites",
addSite: "Ajouter un site",
queueAll: "Tous",
queueAttention: "À risque",
queueDevelopment: "En développement",
nextReviewAtRisk_one: "Examiner {{count}} actif à risque",
nextReviewAtRisk_other: "Examiner {{count}} actifs à risque",
nextOpenJobs_one: "{{count}} intervention ouverte",
nextOpenJobs_other: "{{count}} interventions ouvertes",
nextOpenChecks_one: "{{count}} vérification ouverte",
nextOpenChecks_other: "{{count}} vérifications ouvertes",
a11yAssets_one: "{{count}} actif",
a11yAssets_other: "{{count}} actifs",
emptyTitle: "Aucun site pour le moment",
createSite: "Créer un site",
emptySub: "Créez un site pour regrouper des actifs par emplacement ou portefeuille.",
emptyFilterTitle: "Aucun site correspondant",
emptyFilterSub: "Essayez d'autres termes de recherche ou effacez les filtres.",
clearFilters: "Effacer les filtres",
typeChip: "Type",
lifecycleChip: "Statut",
sortChip: "Trier",
sortNameAsc: "Nom A–Z",
sortNameDesc: "Nom Z–A",
sortNewest: "Plus récent",
sortOldest: "Plus ancien",
insightAttention: "{{count}} à risque",
nextAllClear: "Pas de travail ouvert",
nextAddAssets: "Ajouter des actifs à ce site",
pillAsset: "actif",
pillAssets: "actifs",
pillOnTrack: "En bonne voie",
pillJobs: "interventions",
pillChecks: "vérifications",
exportCsv: "Exporter en CSV",
exportCsvA11y: "Télécharger les sites en CSV",
viewCards: "Vue en cartes",
viewTable: "Vue en tableau",
openSite: "Ouvrir le site",
unassigned: "Non assigné",
managingTeam: "Équipe gestionnaire",
colSite: "Site",
colType: "Type",
colTeam: "Équipe",
colAssets: "Actifs",
colJobs: "Interventions",
colRisk: "À risque",
colStatus: "Statut",
unknownSite: "Site inconnu",
loadErrorTitle: "Nous n'avons pas pu charger vos sites",
loadErrorBlockedTitle: "Les sites ne peuvent pas être affichés",
viewLabel: "Voir",
scopeLabel: "Portée",
csvHeaderName: "Nom",
csvHeaderCode: "Référence",
csvHeaderLifecycle: "Statut",
csvHeaderAddress: "Adresse",
subtitle_many: "{{count}} sites",
nextReviewAtRisk_many: "Examiner {{count}} actifs à risque",
nextOpenJobs_many: "{{count}} interventions ouvertes",
nextOpenChecks_many: "{{count}} vérifications ouvertes",
a11yAssets_many: "{{count}} actifs",
},
detail: {
byPlaceTitle: "Par bâtiment",
byPlaceOpenA11y: "Ouvrir {{name}}",
byPlaceInside_one: "{{count}} à l’intérieur",
byPlaceInside_many: "{{count}} à l’intérieur",
byPlaceInside_other: "{{count}} à l’intérieur",
byPlaceOpenJobs_one: "{{count}} intervention ouverte",
byPlaceOpenJobs_many: "{{count}} interventions ouvertes",
byPlaceOpenJobs_other: "{{count}} interventions ouvertes",
byPlaceDue_one: "{{count}} visite due",
byPlaceDue_many: "{{count}} visites dues",
byPlaceDue_other: "{{count}} visites dues",
byPlaceAtRisk_one: "{{count}} à risque élevé",
byPlaceAtRisk_many: "{{count}} à risque élevé",
byPlaceAtRisk_other: "{{count}} à risque élevé",
  noWorkNoAssets: "Le travail s'affiche ici dès que ce site a des actifs. Ajoutez-en un ou déplacez-en un ici.",
  assignSubtitleTeam: "Choisissez un actif à déplacer ici. Il quitte son site actuel et passe à l'équipe {{team}}.",
  assignSubtitle: "Choisissez un actif à déplacer ici. Il quitte son site actuel, s'il en a un.",
  assignFailedBody: "L'actif n'a pas été déplacé. Vérifiez votre connexion et réessayez.",
  assignRefusedBody: "Vous ne pouvez pas déplacer cet actif. Demandez à la personne qui le gère ou à un administrateur.",
  assignFailedTitle: "Actif non déplacé",
  assignedFallbackAsset: "L'actif",
  assignedToast: "{{asset}} a été déplacé vers {{site}}.",
  archivedBanner: "Ce site est archivé et masqué de vos sites. Restaurez-le pour l'utiliser à nouveau.",
  archivedPill: "Archivé",
  restoredToast: "{{name}} restauré. Il est de retour dans vos sites.",
  archivedToast: "{{name}} archivé. Retrouvez-le sous Archivés dans Sites.",
loading: "Chargement du site…",
addAsset: "Ajouter un actif",
createAsset: "Ajouter un actif",
assignAsset: "Affecter un actif",
assignExistingAsset: "Affecter un actif existant",
siteOptions: "Options du site",
edit: "Modifier",
tabOverview: "Aperçu",
tabDetails: "Détails",
tabAssets: "Actifs",
tabWork: "Travail",
tabReports: "Rapports",
tabEsg: "ESG",
tabContacts: "Contacts",
tabActivity: "Activité",
tabPeople: "Personnes",
refine: "Affiner",
view: "Affichage",
viewList: "Liste",
viewMap: "Carte",
viewNetwork: "Réseau",
filterAttention: "À surveiller",
backToOverview: "Retour à l’aperçu",
kpiAssets: "Actifs",
kpiAtRisk: "À risque",
kpiOpenJobs: "Interventions ouvertes",
kpiOpenInspections: "Inspections ouvertes",
parentSite: "Site parent",
childSites: "Sites enfants",
description: "Description",
noAssets: "Aucun actif sur ce site.",
noAssetsForFilter: "Aucun actif ne correspond à ce filtre.",
noWork: "Aucune intervention ni inspection ouverte.",
noContacts: "Aucun contact lié pour le moment.",
noContactsNeedAssets: "Ajoutez des actifs avant de lier des contacts.",
noActivity: "Aucune activité récente.",
linkContact: "Lier un contact",
selectAssetForContact: "Sélectionner l'actif pour le contact",
linkContactTitle: "Lier un contact à un actif du site",
cancel: "Annuler",
filterAll: "Tous",
openJobs: "Interventions ouvertes",
openInspections: "Inspections ouvertes",
attentionAssets_one: "{{count}} actif nécessite votre attention",
attentionAssets_many: "{{count}} actifs nécessitent votre attention",
attentionAssets_other: "{{count}} actifs nécessitent votre attention",
openJobsCount_one: "{{count}} intervention ouverte",
openJobsCount_many: "{{count}} interventions ouvertes",
openJobsCount_other: "{{count}} interventions ouvertes",
assetsSectionTitle: "Actifs sur ce site",
assetsSectionSub_one: "{{count}} actif",
assetsSectionSub_other: "{{count}} actifs",
filterVehicles: "Véhicules",
descriptionSummary: "Notes et contexte du site",
workBannerNamed: "Travail limité à {{names}}",
contactsForAsset_one: "{{count}} contact",
contactsForAsset_other: "{{count}} contacts",
noContactsForAsset: "Aucun contact lié à cet actif pour le moment.",
archiveConfirmTitle: "Archiver ce site ?",
archiveConfirmMessage: "Il sera masqué de vos sites. Les actifs restent là où ils sont. Vous le retrouverez sous Archivés dans Sites pour le restaurer.",
archive: "Archiver",
archiveFailedTitle: "Impossible d'archiver le site",
archiveFailedMessage: "Le site n'a pas été modifié. Vérifiez votre connexion et réessayez.",
restore: "Restaurer le site",
restoreFailedTitle: "Impossible de restaurer le site",
loadErrorTitle: "Nous n'avons pas pu charger ce site",
loadErrorBlockedTitle: "Ce site ne peut pas être affiché",
goBack: "Retour",
notFoundTitle: "Site introuvable",
notFoundBody: "Ce site a peut-être été archivé ou le lien est obsolète.",
noAssetsForSearch: "Aucun bien ne correspond à votre recherche",
clearSearch: "Effacer la recherche",
searchAssetsPlaceholder: "Rechercher des actifs sur ce site",
kpiAttention: "Attention",
kpiOpenChecks: "Inspections ouvertes",
kpiAssetsInfoDescription: "Actifs affectés à ce site. Les actifs de ses sites enfants sont comptés sur ces sites.",
kpiAssetsInfoBasedOn_one: "{{count}} actif, compté en direct à partir du registre des actifs",
kpiAssetsInfoBasedOn_many: "{{count}} actifs, comptés en direct à partir du registre des actifs",
kpiAssetsInfoBasedOn_other: "{{count}} actifs, comptés en direct à partir du registre des actifs",
kpiAttentionInfoDescription: "Actifs de ce site dont l'état est sous surveillance ou médiocre, ou qui comportent des travaux en retard.",
kpiAttentionInfoBasedOn: "{{count}} actifs sur {{total}}, d’après l’état de santé en temps réel de chaque actif",
kpiJobsInfoDescription: "Interventions sur les actifs de ce site qui ne sont pas encore terminées ou vérifiées.",
kpiJobsInfoBasedOn_one: "{{count}} intervention ouverte sur {{total}} actifs",
kpiJobsInfoBasedOn_many: "{{count}} interventions ouvertes sur {{total}} actifs",
kpiJobsInfoBasedOn_other: "{{count}} interventions ouvertes sur {{total}} actifs",
kpiChecksInfoDescription: "Inspections des actifs de ce site encore ouvertes : commencées et non terminées, ou planifiées et pas encore réalisées.",
kpiChecksInfoBasedOn_one: "{{count}} inspection ouverte sur {{total}} actifs",
kpiChecksInfoBasedOn_many: "{{count}} inspections ouvertes sur {{total}} actifs",
kpiChecksInfoBasedOn_other: "{{count}} inspections ouvertes sur {{total}} actifs",
factsTitle: "Détails",
factCode: "Code du site",
factCategory: "Catégorie",
factType: "Type",
factStatus: "Statut",
factAddress: "Adresse",
factTeam: "Équipe responsable",
factContacts: "Contacts",
factHolds: "Contient",
factCreated: "Créé le",
factUpdated: "Mis à jour le",
factNotSet: "Non renseigné",
factViewOnMap: "Voir sur la carte",
assetsSectionSub_many: "{{count}} actifs",
contactsForAsset_many: "{{count}} contacts",
    tabDocuments: "Documents du site",
    factFloorArea: "Surface",
    floorAreaValue: "{{value}} m² de surface",
},
map: {
  unavailableSub: "La carte n'a pas pu se charger. Vérifiez votre connexion et réessayez.",
  addSiteAddress: "Ajouter l'adresse du site",
noAssetsTitle: "Aucun actif sur ce site",
noAssetsSub: "Ajoutez des actifs pour les voir sur la carte.",
noCoordinatesTitle: "Rien sur la carte pour l'instant",
noCoordinatesSub: "Ajoutez l'adresse du site, ou celles de ses actifs, pour les voir ici.",
unavailableTitle: "Carte indisponible",
coverageShown_one: "Affichage de {{count}} actif cartographié.",
coverageShown_many: "Affichage de {{count}} actifs cartographiés.",
coverageShown_other: "Affichage de {{count}} actifs cartographiés.",
coverageHidden_one: "{{count}} masqué sans coordonnées.",
coverageHidden_many: "{{count}} masqués sans coordonnées.",
coverageHidden_other: "{{count}} masqués sans coordonnées.",
boundarySaveFailedTitle: "Impossible d'enregistrer la limite",
boundarySaveFailedBody: "Le contour n'a pas pu être enregistré.",
boundaryRedraw: "Redessiner la limite",
boundaryDraw: "Tracer une limite",
boundaryRemove: "Supprimer",
boundarySave: "Enregistrer la limite",
boundaryUndo: "Annuler",
boundaryTapFirstCorner: "Appuyez sur la carte pour placer le premier coin",
boundaryCornersAdjust: "{{count}} coins — faites glisser l’un d’eux pour l’ajuster",
boundaryCornersOfThree: "Coins : {{count}} sur 3",
},
network: {
noAssetsTitle: "Aucun actif à connecter",
noAssetsSub: "Ajoutez au moins deux actifs pour explorer les relations.",
singleAssetTitle: "Un actif sur ce site",
singleAssetSub: "Liez cet actif à d'autres depuis sa page de détail pour construire un réseau.",
openAsset: "Ouvrir l'actif",
},
assetLink: {
label: "Site",
helper: "Le lieu où se trouve cet actif.",
none: "Aucun site assigné",
open: "Ouvrir le site",
rowHelper: "Facultatif. Le lieu où se trouve cet actif.",
a11ySelected: "Site : {{name}}. Changer de site.",
a11yUnselected: "Sélectionnez le site, en option",
clearSite: "Effacer le site",
selectSite: "Sélectionnez le site",
},
kind: {
  status: {
    decommissioned: "Hors service",
    under_renovation: "En rénovation",
    partially_operational: "Partiellement en service",
    operational: "En service",
    handover: "En cours de remise",
    partially_developed: "Partiellement construit",
    in_development: "En construction",
    planned: "Prévu",
  },
  type: {
    other: "Autre",
    building: "Bâtiment",
    corridor: "Tracé (route, voie ferrée ou canalisation)",
    data_centre: "Centre de données",
    hotel: "Hôtel",
    hospital: "Hôpital",
    airport: "Aéroport",
    shopping_centre: "Centre commercial",
    substation: "Poste électrique",
    project_site: "Site de projet",
    construction_site: "Chantier",
    parking_facility: "Parking",
    terminal: "Terminal",
    port: "Port",
    distribution_centre: "Centre de distribution",
    warehouse: "Entrepôt",
    workshop: "Atelier",
    fleet_hub: "Centre de flotte",
    garage: "Garage",
    yard: "Parc de stockage",
    depot: "Dépôt",
    plant: "Site de production",
    factory: "Usine",
    industrial_park: "Zone industrielle",
    office_building: "Immeuble de bureaux",
    campus: "Campus",
    retail_park: "Parc commercial",
    business_park: "Parc d'affaires",
    scheme: "Programme immobilier",
    neighbourhood: "Quartier",
    estate: "Lotissement",
  },
  category: {
    other: "Autre",
    mixed_use: "Usage mixte",
    healthcare: "Santé",
    hospitality: "Hôtellerie",
    temporary: "Temporaire / projet",
    infrastructure: "Infrastructure",
    logistics: "Logistique et stockage",
    fleet_transport: "Flotte et transport",
    industrial: "Industriel",
    commercial: "Commercial",
    residential: "Résidentiel",
  },
  statusLabel: "Statut",
  typeLabel: "Lequel correspond le mieux ?",
  categoryLabel: "De quel type de lieu s'agit-il ?",
},
create: {
  createdBackToAsset: "{{name}} est créé et choisi pour votre actif.",
  created: "{{name}} est créé. Ajoutez ses actifs depuis cette page.",
  unsavedGuardMessage: "Ce site n'est pas enregistré. Quitter et perdre ce que vous avez saisi ?",
pageTitle: "Nouveau site",
newSiteKicker: "Nouveau site",
unnamedSite: "Site sans nom",
addNotesFirstTitle: "Ajouter des notes en premier",
addNotesFirstBody: "Tapez ou dictez un court brouillon, puis utilisez Améliorer avec l'IA.",
improvedSiteNotesTitle: "Notes de site améliorées",
unableToImproveNotesTitle: "Impossible d'améliorer les notes",
improveNotesRationale: "Consultez les notes améliorées avant de les appliquer au site.",
improveNotesFailed: "Impossible d'améliorer les notes. Veuillez réessayer.",
nameRequiredTitle: "Nom requis",
nameRequiredBody: "Saisissez un nom pour le site.",
invalidTypeTitle: "Choisissez à nouveau le type",
invalidTypeBody: "Ce type ne correspond pas au type de lieu choisi. Choisissez-en un dans la liste.",
createFailedTitle: "Impossible de créer le site",
createFailedBody: "Le site n'a pas été créé. Vérifiez votre connexion et réessayez.",
labelType: "Type de site",
labelLifecycle: "Statut",
labelParent: "Parent",
labelManagingTeam: "Équipe gestionnaire",
labelAddress: "Adresse",
labelName: "Nom",
labelCode: "Référence",
fallbackDash: "—",
basicsNameLabel: "Nom *",
siteNameA11y: "Nom du site (obligatoire)",
siteNamePlaceholder: "p. ex. Domaine d'Oakwood",
codeLabel: "Référence (facultatif)",
codeHint: "Votre code court pour ce site, si vous en utilisez un.",
codeA11y: "Référence (facultatif)",
codePlaceholder: "ex. NDEP-01",
parentSiteLabel: "Site parent",
parentSiteHelper: "Facultatif. Placez-le dans un lotissement, un dépôt ou un campus.",
managingTeamHelper: "Les actifs ajoutés à ce site sont confiés à cette équipe.",
addressLabel: "Adresse (facultatif)",
descriptionLabel: "Description (optionnel)",
descriptionA11y: "Description (optionnel)",
descriptionPlaceholder: "Notes d'accès, détails de phase ou contexte de transfert",
dictate: "Dicter",
stopDictation: "Arrêter",
improving: "Amélioration...",
improveWithAi: "Améliorer avec l'IA",
stepBasicsTitle: "Les bases",
stepBasicsWhy: "Donnez un nom au site. C'est tout ce qu'il faut ; le reste est facultatif.",
stepLocationTitle: "Où est-il ?",
stepLocationWhy: "Ajoutez l'adresse pour qu'on puisse le trouver.",
stepClassifyTitle: "Type de site",
stepClassifyWhy: "Indiquez le type de lieu et s'il est en service.",
stepStructureTitle: "Site parent et équipe",
stepStructureWhy: "Placez-le dans un site plus grand et choisissez l'équipe qui s'en occupe.",
saving: "Enregistrement…",
createSite: "Créer un site",
parentSiteModalTitle: "Site parent",
managingTeamModalTitle: "Équipe gestionnaire",
},
team: {
managingTeam: "Équipe gestionnaire",
managingTeamHelper: "Les actifs de ce site héritent de cette équipe lors de leur ajout ou quand vous la modifiez ici.",
selectTeam: "Sélectionner une équipe",
optional: "Facultatif",
pickerTitle: "Équipe gestionnaire",
noneAssigned: "Aucune équipe assignée",
cascadeConfirmTitle: "Mettre à jour les équipes des actifs ?",
cascadeConfirmMessage_one: "{{count}} actif de ce site sera réaffecté à {{team}}.",
cascadeConfirmMessage_other: "{{count}} actifs de ce site seront réaffectés à {{team}}.",
cascadeConfirmAction: "Mettre à jour l'équipe",
updateFailedTitle: "Impossible de mettre à jour l'équipe",
updateFailedMessage: "Veuillez réessayer.",
rowHelper: "Les actifs ajoutés à ce site héritent de cette affectation d'équipe.",
a11ySelected: "Équipe gestionnaire : {{name}}. Changer d'équipe.",
a11yUnselected: "Sélectionner l'équipe de gestion, en option",
clearTeam: "Effacer l'équipe",
cascadeConfirmMessage_many: "{{count}} actifs de ce site seront réaffectés à {{team}}.",
},
picker: {
dismissA11y: "Fermer le sélecteur de site",
closeA11y: "Fermer le sélecteur de site",
searchPlaceholder: "Rechercher des sites...",
loadingSites: "Chargement des sites",
emptyResults: "Aucun site trouvé. Créez-en un ci-dessous ou annulez pour revenir en arrière.",
selectItemA11y: "Sélectionnez {{name}}",
},
report: {
placeTitle: "{{place}} · {{site}}",
  generateFailedBody: "Un problème est survenu. Réessayez dans une minute.",
  shareFailedTitle: "Impossible d’enregistrer le rapport",
  shareGenerated: "Rédigé par l’IA le {{date}}. Vérifiez-le avant de vous y fier.",
  shareTitle: "Rapport de site : {{name}}",
  pdfDocType: "Rapport de site",
  pdfSummary: "Résumé du site",
  pdfType: "Type de site",
  pdfStatus: "Statut",
  pdfTeam: "Équipe responsable",
  pdfAddress: "Adresse",
  pdfAssetCount: "Actifs",
  pdfAssetsHeading: "Actifs de ce site",
  pdfColAsset: "Actif",
  pdfColType: "Type d'actif",
  pdfColStatus: "Statut",
  sharePdf: "Enregistrer ou partager en PDF",
  internetResearchHint: "Désactivé : le rapport n’utilise que vos données. Activé : il cherche aussi sur le web, par exemple les rappels pour cette marque et ce modèle.",
  internetResearchA11y: "Chercher aussi des informations publiques en ligne",
  internetResearch: "Chercher aussi des informations publiques en ligne",
loadHistoryFailedTitle: "Impossible de charger l'historique du rapport",
unknownError: "Erreur inconnue",
selectAnalysisTypeTitle: "Sélectionnez au moins un type d'analyse",
selectAnalysisTypeBody: "Choisissez une ou plusieurs sections avant de générer le rapport.",
generateFailedTitle: "Le rapport de site n’a pas été généré",
summaryPlaceholder: "Générez ou chargez un rapport de site avancé pour connaître le risque, l'état, la conformité et les recommandations du portefeuille pour chaque actif de ce site.",
actionSelectType: "Sélectionnez au moins un type d'analyse.",
actionGenerate: "Générez le rapport de site.",
analysisSiteOverview: "Vue d'ensemble du site",
analysisAssets: "Actifs",
analysisMaintenance: "Maintenance",
analysisRisk: "Risque",
analysisHealth: "Santé",
analysisCompliance: "Conformité",
analysisComparisons: "Comparaisons",
contextBadge: "Rapport IA",
fallbackTitle: "Rapport de site",
metaKind: "Rapport IA",
heroTitle: "Générer un rapport de site",
heroSub: "L’IA rédige un rapport à partir de chaque actif du site : inspections, interventions, documents et risques.",
includeAnalysis: "Inclure l'analyse",
toggleAnalysisA11y: "Basculer l’analyse {{label}}",
generateButton: "Générer un rapport",
snapshotComparison: "Rapports précédents",
latestSnapshotLine: "Dernier : {{date}}",
previousSnapshotLine: "Précédent: {{date}}",
noPreviousSnapshot: "Pas encore de rapport précédent.",
insightTitle: "Résumé du rapport de site",
signalRisk: "Le risque est {{level}} ({{score}}).",
signalHealth: "La santé est {{status}} ({{score}}).",
signalCompliance: "La conformité est {{posture}} ({{score}}).",
signalLatestSnapshot: "Dernier rapport enregistré : {{date}}.",
signalNoSnapshot: "Aucun rapport n’a encore été enregistré.",
signalAnalysisSelected_one: "{{count}} type d'analyse est sélectionné.",
signalAnalysisSelected_other: "{{count}} types d'analyse sont sélectionnés.",
signalSnapshotsAvailable_one: "{{count}} rapport enregistré est disponible.",
signalSnapshotsAvailable_other: "{{count}} rapports enregistrés sont disponibles.",
signalNoSnapshotsAvailable: "Aucun rapport enregistré pour l’instant.",
metricSnapshots: "Rapports enregistrés",
sourceGenerated: "Rédigé par l’IA",
sourceSnapshot: "Dernier rapport enregistré",
sourceSetup: "Pas encore généré",
executiveSummary: "Résumé",
riskHealthCompliance: "Risque / santé / conformité",
riskLine: "Risque : {{level}} ({{score}})",
healthLine: "Santé : {{status}} ({{score}})",
complianceLine: "Conformité : {{posture}} ({{score}})",
maintenanceService: "Maintenance et service",
recommendations: "Recommandations",
recommendationLine: "- {{recommendation}}",
noReportYet: "Pas encore de rapport de site. Touchez Générer le rapport.",
sources: "Sources",
sourceLine: "- [{{sourceType}}] {{title}}",
signalAnalysisSelected_many: "{{count}} types d'analyse sont sélectionnés.",
signalSnapshotsAvailable_many: "{{count}} rapports enregistrés sont disponibles.",
},
edit: {
  parentLoopBody: "Un site ne peut pas être placé dans lui-même ni dans l'un de ses propres sites.",
  parentLoopTitle: "Choisissez un autre site",
  updateFailedBody: "Vos modifications n'ont pas été enregistrées. Vérifiez votre connexion et réessayez.",
  saved: "{{name}} enregistré.",
pageTitle: "Modifier le site",
unsavedGuardMessage: "Vous avez des modifications non enregistrées sur ce site. Partir et les perdre ?",
unsavedGuardDiscard: "Quitter",
unsavedGuardKeep: "Continuer à modifier",
updateFailedTitle: "Impossible de mettre à jour le site",
loadErrorTitle: "Impossible de charger ce site",
loadErrorWithMessage: "{{message}}. Vérifiez votre connexion et réessayez.",
loadErrorGeneric: "Vérifiez votre connexion et réessayez.",
save: "Enregistrer",
archiveConfirmMessage: "Il sera masqué de vos sites. Les actifs restent là où ils sont. Vous le retrouverez sous Archivés dans Sites pour le restaurer.",
siteNameA11y: "Nom du site",
codeA11y: "Code",
descriptionA11y: "Description",
archiveSite: "Archiver le site",
    floorArea: "Surface (m²)",
    floorAreaPlaceholder: "ex. 2400",
    floorAreaHint: "Sert dans ESG pour l’énergie et le carbone par m². Laissez vide si inconnue.",
    floorAreaInvalid: "Saisissez la surface en mètres carrés.",
},
intake: {
pageTitle: "Signaler un problème",
errorTitleMissing: "Dites-nous ce qui se passe.",
errorDescriptionMissing: "Ajoutez quelques détails pour que l'équipe puisse vous aider.",
errorNameMissing: "Votre nom est requis.",
errorEmailInvalid: "Saisissez une adresse e-mail valide.",
errorPhoneInvalid: "Saisissez un numéro de téléphone valide pour le pays sélectionné.",
errorContactMissing: "Ajoutez un e-mail ou un téléphone pour que l'équipe puisse répondre.",
uploadFailed: "Nous n'avons pas pu télécharger vos photos. Supprimez-les ou réessayez.",
errorNotAvailable: "Ce lien n'accepte pas les demandes pour le moment.",
errorSubmitterDetailsRequired: "Veuillez ajouter votre nom et un e-mail ou un numéro de téléphone.",
errorSubmitGeneric: "Nous n'avons pas pu soumettre votre demande. Veuillez réessayer.",
contactLabel: "Contact",
addressLabel: "Adresse",
linkIncompleteTitle: "Lien incomplet",
linkIncompleteBody: "Il manque la référence de l'actif au lien que vous avez ouvert. Essayez à nouveau de scanner le code QR.",
unavailableTitle: "Ce lien n'accepte pas les demandes",
unavailableBody: "Le signalement est désactivé pour ce code, ou le code n’est plus valable. Prévenez les personnes qui s’occupent du lieu, par exemple l’accueil ou le bureau du site.",
sentTitle: "Merci, nous l'avons bien reçu",
sentBody: "{{company}} a reçu votre signalement. L’équipe vous contactera par e-mail ou téléphone si besoin. Vous pouvez fermer cette page.",
fallbackTeam: "L'équipe",
reportAnother: "Signaler un autre problème",
reportAnotherA11y: "Signaler un autre problème sur cet actif",
beforeYouSend: "Avant d'envoyer",
deflectTitle: "Cela pourrait résoudre le problème plus rapidement",
deflectIntro_one: "Nous avons trouvé un guide pour cet actif qui répond peut-être déjà à votre problème. Jetez-y un œil rapide — si cela résout votre problème, c'est parfait. Sinon, envoyez votre demande ci-dessous.",
deflectIntro_other: "Nous avons trouvé {{count}} guides pour cet actif qui répondent peut-être déjà à votre problème. Jetez-y un œil rapide — si cela résout votre problème, c'est parfait. Sinon, envoyez votre demande ci-dessous.",
kbFaq: "FAQ",
kbHowTo: "COMMENT FAIRE",
collapseGuideA11y: "Réduire {{title}}",
expandGuideA11y: "Développer {{title}}",
openFullGuide: "Ouvrir le guide complet",
openGuideA11y: "Ouvrir le guide : {{title}}",
stillSend: "Envoyer quand même ma demande",
stillSendA11y: "Envoyer ma demande quand même",
backToRequest: "Retour à ma demande",
backToRequestA11y: "Retourner pour modifier ma demande",
formTitle: "Dites-nous ce qui se passe",
introWithAsset: "Vous signalez un problème avec {{assetName}}. ",
introBody: "L'équipe verra votre message et vous répondra — ajoutez votre nom et un e-mail ou un téléphone afin qu'elle puisse vous joindre.",
fieldWhatsHappening: "Que se passe-t-il ?",
titlePlaceholder: "Résumé sur une ligne — par ex. \"pas d'eau chaude dans l'unité 3\"",
titleA11y: "Que se passe-t-il (obligatoire)",
fieldDetails: "Détails",
detailsPlaceholder: "Décrivez le problème — ce qui ne va pas, où, et depuis quand",
detailsA11y: "Détails (obligatoire)",
fieldPhotos: "Photos",
photosOptionalHint: "(en option, jusqu'à 2)",
removePhotoA11y: "Supprimer la photo {{index}}",
addPhotoA11y: "Ajouter une photo",
addPhotoLabel: "Ajouter une photo",
fieldYourName: "Votre nom",
namePlaceholder: "Pour qu'ils sachent qui ils aident",
nameA11y: "Votre nom (obligatoire)",
fieldEmail: "E-mail",
emailPlaceholder: "Pour qu'ils puissent répondre",
fieldPhone: "Téléphone",
phonePlaceholder: "Au cas où ils auraient besoin d'appeler",
contactHint: "Nous l'utiliserons uniquement pour vous répondre au sujet de votre signalement.",
sending: "Envoi…",
checkingFix: "Recherche d'une solution rapide…",
sendRequest: "Envoyer la demande",
deflectIntro_many: "Nous avons trouvé {{count}} guides pour cet actif qui répondent peut-être déjà à votre problème. Jetez-y un œil rapide — si cela résout votre problème, c'est parfait. Sinon, envoyez votre demande ci-dessous.",
},
knowledge: {
  goToAssets: "Aller aux actifs",
backButton: "Retour",
title: "Connaissances",
subtitle: "Recherchez parmi vos actifs",
unknownAsset: "Actif inconnu",
anyAsset: "Tous les actifs",
moreAssetsSummary: "{{first}}, {{second}} +{{count}} autres",
openItemA11y: "Ouvrir {{title}}, {{kind}} sur {{asset}}",
untitledItemA11y: "élément de connaissance",
untitled: "Sans titre",
searchPlaceholder: "Rechercher les connaissances",
refineResults: "Affiner les résultats",
refineTypeLabel: "Type",
refineAssetLabel: "Actif",
assetSummaryA11y: "Actif : {{summary}}",
removeAssetA11y: "Retirer {{name}}",
signInTitle: "Connectez-vous pour rechercher vos connaissances",
signInBody: "Votre session a expiré, rien n'a donc pu être recherché. Connectez-vous à nouveau pour continuer.",
searchErrorTitle: "Impossible d'exécuter cette recherche",
tryAgain: "Réessayer",
noMatchesTitle: "Aucun résultat",
noMatchesBody: "Aucun résultat. Essayez d’autres mots, ou ajoutez-le : ouvrez l’actif, allez dans Connaissances et touchez Ajouter.",
noFilterMatchesTitle: "Rien ne correspond à ces filtres",
filteredEmptyBody_one: "{{count}} résultat correspond à la recherche, mais aucun ne correspond à l'actif ou au type choisi.",
filteredEmptyBody_other: "{{count}} résultats correspondent à la recherche, mais aucun ne correspond à l’actif ou au type choisi.",
introTitle: "Rechercher dans votre base de connaissances",
introBody: "Trouvez modes d’emploi, FAQ, notes, fichiers et liens sur tous les actifs. Tapez au moins deux lettres. Pour ajouter des connaissances, ouvrez un actif, allez dans Connaissances et touchez Ajouter.",
shareOpenLinkFailedTitle: "Impossible d'ouvrir le lien",
shareInvalidLink: "Lien invalide",
shareTimeoutMessage: "Le chargement de cette bibliothèque partagée prend trop de temps. Vérifiez votre connexion et réessayez.",
shareLoadFailed: "Impossible de charger les connaissances partagées",
shareUnableToLoad: "Impossible de charger",
shareEmptyTitle: "Rien à afficher",
shareEmptyBody: "Ce partage a peut-être été révoqué ou aucun article n'y a encore été publié.",
shareOpenLink: "Ouvrir le lien",
shareOpenFile: "Ouvrir le fichier",
shareClose: "Fermer",
filteredEmptyBody_many: "{{count}} résultats correspondent à la recherche, mais aucun ne correspond à l’actif ou au type choisi.",
},
  documents: {
    title: "Documents du site",
    sub: "Les documents du bâtiment entier, comme son EPC ou son DEC. Les documents d’un équipement restent sur l’équipement.",
    add: "Ajouter un document",
    open: "Ouvrir",
    edit: "Modifier",
    archive: "Archiver",
    cancel: "Annuler",
    archiveTitle: "Archiver ce document ?",
    archiveBody: "{{title}} quitte cette liste. Le fichier et l’historique sont conservés.",
    archiveFailed: "Impossible d’archiver le document. Réessayez.",
    loadFailed: "Impossible de charger les documents.",
    retry: "Réessayer",
    emptyTitle: "Aucun document de site",
    emptyBody: "Ajoutez ici les certificats du bâtiment, comme son EPC ou son DEC.",
    validUntil: "Valable jusqu’au {{date}}",
    expired: "Expiré le {{date}}",
  },
};
